import { render, staticRenderFns } from "./SummaryVeds.vue?vue&type=template&id=0793b6a6&scoped=true&"
import script from "./SummaryVeds.vue?vue&type=script&lang=js&"
export * from "./SummaryVeds.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVeds.vue?vue&type=style&index=0&id=0793b6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0793b6a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBreadcrumbs,VDataTable,VIcon,VLayout})
